import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_4 = { class: "mt-0" }
const _hoisted_5 = { class: "d-flex justify-end mb-5" }

import { ref, Ref, onMounted, watch } from 'vue';
import i18n from '@/lang/i18n';
import { useRouter } from 'vue-router';
import Api from '@/services/api/ApiServiceFabrick';
import AuthorityCacheApi from '@/services/models/AuthorityCacheApi';
import SearchForm from '@/components/GpsTrackerSetting/SearchForm.vue';
import GpsTrackerSettingTable from '@/components/GpsTrackerSetting/GpsTrackerSettingTable.vue';
import PaginateWithCount from '@/components/PaginateWithCount.vue';
import getGpsTrackerSettingListRequest from '@/types/requests/getGpsTrackerSettingList'
import getGpsTrackerSettingListResponse from '@/types/responses/getGpsTrackerSettingList'
import getGpsTrackerSettingResponse from '@/types/responses/getGpsTrackerSetting'


export default /*@__PURE__*/_defineComponent({
  __name: 'GpsTrackerSettingList',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props

const router = useRouter()
const isLoading: Ref<boolean> = ref(false)
const showableDeleteButton = ref(false)
const gpsTrackerSettings: Ref<getGpsTrackerSettingResponse[]> = ref([])
const currentPage = ref(1)
const totalPage = ref(1)
const searchParams: Ref<getGpsTrackerSettingListRequest> = ref({ operation_office_id: null, page: 1 })

function moveToForm() {
  router.push('/gps-tracker-settings/form/')
}

function fetchList() {
  isLoading.value = true
  Api().getGpsTrackerSettingList(searchParams.value)
    .then((data: getGpsTrackerSettingListResponse) => {
      gpsTrackerSettings.value = data.gps_tracker_settings
      totalPage.value = data.total_page
      currentPage.value = data.current_page
    })
    .finally(() => {
      isLoading.value = false
    })
}

function searchList(params: { operationOffice: { id: number } | null }) {
  searchParams.value = { operation_office_id: params.operationOffice?.id ?? null, page: 1 }
  currentPage.value = 1
  fetchList()
}

function onDeleteClick(id: number) {
  if (!confirm(i18n.global.t('common.confirmationModal.confirmDelete'))) return
  Api().deleteGpsTrackerSetting(id)
    .then(() => {
      fetchList()
    })
    .catch(() => {
      props.showFlash(i18n.global.t('pages.common.messages.failedDelete'), 'error', true)
    })
}

watch(currentPage, (page) => {
  searchParams.value = { ...searchParams.value, page }
  fetchList()
})

onMounted(() => {
  fetchList()
  AuthorityCacheApi.getWithParse().then((authorityList) => {
    showableDeleteButton.value = !!authorityList['octlink.gps_tracker_settings.delete']
  })
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerSetting.title')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_btn, {
            class: "exec-btn mt-0",
            onClick: moveToForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.newCreate')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(GpsTrackerSettingTable, {
          class: "mb-2",
          isLoading: isLoading.value,
          gpsTrackerSettings: gpsTrackerSettings.value,
          showDeleteButton: showableDeleteButton.value,
          onDelete: onDeleteClick
        }, null, 8, ["isLoading", "gpsTrackerSettings", "showDeleteButton"]),
        _createVNode(PaginateWithCount, {
          class: "justify-end",
          totalPage: totalPage.value,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
          showItemCount: false
        }, null, 8, ["totalPage", "modelValue"])
      ])
    ]),
    _createVNode(SearchForm, {
      isLoading: isLoading.value,
      onSearch: searchList
    }, null, 8, ["isLoading"])
  ]))
}
}

})